import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import SliderListItem from '../../../../../../list-items/SliderListItem/SliderListItem';

const BackdropDriftIntensitySlider = (props) => {
    const { intensity, customMode, updateBackgroundSettings } = props;

    const onIntensityChange = useCallback((value) => {
        if (value === intensity) return;
        updateBackgroundSettings({ drift: { intensity: value } });
    }, [intensity, updateBackgroundSettings]);

    return (
        <SliderListItem
            title='Intensity'
            displayMultiplier={1}
            value={intensity}
            min={0}
            max={100}
            step={1}
            onValueChange={onIntensityChange}
            disabled={customMode}
        />
    );
};

const mapStateToProps = (state) => {
    const drift = state.createPreview.present.videoSettings.background.drift;
    return {
        intensity: drift?.intensity ?? 0,
        customMode: Boolean(drift?.customMode)
    };
};

const mapDispatchToProps = (dispatch) => {
    const updateBackgroundSettings = (properties) => dispatch(createActions.updateBackgroundSettings(properties));
    return { updateBackgroundSettings };
};

export default connect(mapStateToProps, mapDispatchToProps)(BackdropDriftIntensitySlider);
